module.exports = __webpack_public_path__ + "img/30.db199863.jpg";